import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueCountdownTimer from 'vuejs-countdown-timer';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
Vue.use(Viewer);
Vue.use(VueCountdownTimer);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
